import { React, Link, styled, Image, Filters, mq } from 'x'
import { Row, Col, H3 } from 'components/common'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import referencesQuery from 'components/static/referencesQuery'
import {Post} from '../../templates/post'

const Container = styled.div`
  padding: 30px 30px 60px 30px;
  background-color: #fff;
  @media (min-width: 2000px) {
    max-width:1366px;
    margin:0 auto;
  }
`

const SliderItem = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center; 
  justify-content: center;
  text-align: center;
  height:100%;
  padding:0 15px;
  box-sizing: border-box;
`

const Title = styled(H3)`
  text-align: center;
  color: #3e4d72;
  font-weight:800;
  line-height:1.2;
  width:100%;
  margin-bottom:0;

  ${mq.below('sm')} {
    font-size: 32px;
  }
`

const SubTitle = styled.p`
  text-align: center;
  color: #3e4d72;
  line-height:1.2;
  width:100%;
  margin-top:0;
`

const LogoCarousel = props => {

  const slides = props.data.clients

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 5500, min: 1200 },
      items: 6
    },
    desktop: {
      breakpoint: { max: 1200, min: 768 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 3
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  }

  return (
    <Container>
      <Row>
        <Col>
          <Title>We are a Trusted Provider</Title>
          <SubTitle>We work with many corporate partners to provide excellent training solutions to meet the demands of fast moving tech industry.</SubTitle>
        </Col>
      </Row>
      <Carousel responsive={responsive} infinite={true} autoPlay={true} arrows={false} autoPlaySpeed={5000}>
        {slides.map((slide, index) => (
          <SliderItem key={'slide-' + index} >
            {slide?.acf?.thumbnail?.imgixImageWp?.fluid && (
                <Image
                  fluid={{ ...slide.acf.thumbnail.imgixImageWp.fluid }}
                  title={slide.title}
                  style={{width: '100px', height: 'auto'}}
                />
            )}
          </SliderItem>
        ))}
      </Carousel>
    </Container>
  )
}

export default referencesQuery(LogoCarousel)
